export const getCellDataMappedCols = (mapperObj, columns) => {
  let mappedCols = []
  try {
    if (columns?.length > 0) {
      const cols = columns?.map(col => {
        return mapperObj[col?.name_of_db_column]
          ? {
              ...col,
              cellData: mapperObj[col?.name_of_db_column],
            }
          : {
              ...col,
            }
      })
      mappedCols = cols
    }
  } catch (err) {
    console.log('Error: ', err?.message)
  }

  return mappedCols || columns
}
